import { supabase, LabAnalyzerImport, LabAnalyzerImportDetail } from '../lib/supabase';
import { getTenantId } from '../contexts/TenantContext';

export const labAnalyzerImportService = {
  async getAll(): Promise<LabAnalyzerImport[]> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('lab_analyzer_imports')
      .select('*')
      .eq('tenant_id', tenantId)
      .is('deleted_at', null)
      .order('import_date', { ascending: false });

    if (error) throw error;
    return data || [];
  },

  async getById(id: string): Promise<LabAnalyzerImport | null> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('lab_analyzer_imports')
      .select('*')
      .eq('id', id)
      .eq('tenant_id', tenantId)
      .is('deleted_at', null)
      .single();

    if (error) throw error;
    return data;
  },

  async create(importData: Omit<LabAnalyzerImport, 'id' | 'tenant_id' | 'created_at' | 'updated_at' | 'deleted_at'>): Promise<LabAnalyzerImport> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('lab_analyzer_imports')
      .insert({ ...importData, tenant_id: tenantId })
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async update(id: string, importData: Partial<LabAnalyzerImport>): Promise<LabAnalyzerImport> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('lab_analyzer_imports')
      .update(importData)
      .eq('id', id)
      .eq('tenant_id', tenantId)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async delete(id: string): Promise<void> {
    const tenantId = getTenantId();
    const { error } = await supabase
      .from('lab_analyzer_imports')
      .update({ deleted_at: new Date().toISOString() })
      .eq('id', id)
      .eq('tenant_id', tenantId);

    if (error) throw error;
  },

  async getImportDetails(importId: string): Promise<LabAnalyzerImportDetail[]> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('lab_analyzer_import_details')
      .select('*')
      .eq('tenant_id', tenantId)
      .eq('import_id', importId)
      .order('created_at', { ascending: true });

    if (error) throw error;
    return data || [];
  },

  async createImportDetail(detail: Omit<LabAnalyzerImportDetail, 'id' | 'tenant_id' | 'created_at'>): Promise<LabAnalyzerImportDetail> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('lab_analyzer_import_details')
      .insert({ ...detail, tenant_id: tenantId })
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async updateImportDetail(id: string, detail: Partial<LabAnalyzerImportDetail>): Promise<LabAnalyzerImportDetail> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('lab_analyzer_import_details')
      .update(detail)
      .eq('id', id)
      .eq('tenant_id', tenantId)
      .select()
      .single();

    if (error) throw error;
    return data;
  }
};
